import { HStack, Text, IconButton } from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";

interface SectionHeaderProps {
	title: string;
	onEdit: () => void;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, onEdit }) => {
	return (
		<HStack justifyContent="space-between">
			<Text
				color="gray.600"
				fontSize="16px"
				fontWeight="600"
				lineHeight="normal"
				width="182px"
				height="32px"
				flexShrink="0">
				{title}
			</Text>
			<IconButton aria-label="Edit section" icon={<EditIcon />} variant="ghost" color="gray.600" onClick={onEdit} />
		</HStack>
	);
};

export default SectionHeader;
